import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import helperNumbers from "../../../helpers/numbers";
import helperTime from "../../../helpers/time";
import httpService from "../../../services/httpServices/httpServices";
import StatusAskTransaction from "./StatusAskTransaction";
import Pagination from "../../partials/content/Pagination";

export default function AllAskTransaction() {
  const [allAskTransaction, setAllAskTransaction] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [amountSearchFilter, setAmountSearchFilter] = useState(0);

  useEffect(() => {
    getAllAskTransaction();
  }, [currentPage, amountSearchFilter]);

  const getAllAskTransaction = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allAskTransaction = await sendRequestGetAllAskTransaction(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allAskTransaction) {
      return;
    }

    setAllAskTransaction(allAskTransaction.ask_transaction);
    setCountPage(allAskTransaction.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (amountSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&price=${amountSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const sendRequestGetAllAskTransaction = async (searchFilterQuery) => {
    const headersRequest = getHeaderRequest();
    let allAskTransaction;
    try {
      allAskTransaction = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/publisher/ask-transaction?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allAskTransaction.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateDoseNotHaveAnyAskTransaction = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img src="/assets/img/do-not-have-position.svg" />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p> شما در حال حاضر شما هیچ درخواست انتقال وجه ای ندارید :(</p>
          <p> برای شروع کار یک درخواست انتقال وجه جدید بسازید.</p>
          <p>
            <Link to="/finance/ask-transaction/add" className="btn btn-success">
              <span className="pl-2">
                <i className="fa fa-plus"> </i>
              </span>
              <span>درخواست انتقال وجه جدید</span>
            </Link>
          </p>
        </div>
      </div>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateAskTransaction = () => {
    return (
      <>
        <div className="pb-2">
          <Link to="/finance/ask-transaction/add" className="btn btn-success">
            <span className="pl-2">
              <i className="fa fa-plus"> </i>
            </span>
            <span>درخواست انتقال وجه جدید</span>
          </Link>
        </div>

        <div class="container-fluid pb-2">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در مبلغ</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="number"
                  onKeyUp={(e) => setAmountSearchFilter(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  placeholder="مبلغ  را در اینجا وارد کنید"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره درخواست</td>
                <td>مبلغ</td>
                <td>نام مالک حساب</td>
                <td>نام بانک</td>
                <td>وضعیت</td>
                <td>تاریخ ارسال درخواست</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allAskTransaction.map((item, index) => {
                let classBadgeStatePage;
                switch (item.status) {
                  case StatusAskTransaction.getStatusAskTransactionString()[
                    StatusAskTransaction.statusAskTransaction.PENDING
                  ]:
                    classBadgeStatePage = "badge-warning";
                    break;
                  case StatusAskTransaction.getStatusAskTransactionString()[
                    StatusAskTransaction.statusAskTransaction.PAID
                  ]:
                    classBadgeStatePage = "badge-info";
                    break;
                  case StatusAskTransaction.getStatusAskTransactionString()[
                    StatusAskTransaction.statusAskTransaction.REJECT
                  ]:
                    classBadgeStatePage = "badge-danger";
                    break;
                }
                return (
                  <tr>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td>{helperNumbers.toPersianNum(item.id)}</td>
                    <td className="letter-spacing-finance-number">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(item.price)
                      )}
                    </td>
                    <td>{item.owner_account_name}</td>
                    <td>{item.bank_name}</td>
                    <td>
                      <span className={`badge ${classBadgeStatePage}`}>
                        {item.status}
                      </span>{" "}
                    </td>
                    <td>
                      {helperNumbers.toPersianNum(
                        item.created_at.split(" ")[1] +
                          " " +
                          helperTime.convertGregorianToJalali(
                            item.created_at.split(" ")[0]
                          )
                      )}
                    </td>
                    <td>
                      <Link
                        to={`/finance/ask-transaction/info/${item.id}`}
                        className="btn btn-info"
                      >
                        <i className="fa fa-info"></i>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="finance" activeItem="all-ask-transaction" />

      <div className="content-wrapper">
        <TitleBar title="درخواست انتقال موجودی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {allAskTransaction.length == 0 && amountSearchFilter == 0
                ? generateDoseNotHaveAnyAskTransaction()
                : generateAskTransaction()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
